// NEW: UI_REVAMP
import { Box, Flex, Text } from '@chakra-ui/react';
import ImgComp from '../../utils/ImgComp';
import GradientBox from '../box/GradientBox';
import OptionTabList from '../tabs/OptionTabList';

const ResultGameTabLabel = ({ item }) => {
	return (
		<>
			{item.logo && (
				<GradientBox
					borderRadius='full'
					display='flex'
					w={{ base: 5, lg: '32px' }}
					h={{ base: 5, lg: '32px' }}
					flexShrink={0}
					justifyContent='center'
					alignItems='center'
					boxShadow='none'
					p='1px'
				>
					<Flex
						borderRadius='full'
						bg='white'
						w='full'
						h='full'
						p={item.value?.toLowerCase() !== 'mandaue' ? { base: '2px', lg: '3px' } : undefined}
						justifyContent='center'
						alignItems='center'
					>
						<ImgComp svgName={item.value.toLowerCase()} w='full' h='full' objectFit='contain' />
					</Flex>
				</GradientBox>
			)}
			<Text fontSize={{ base: '12px', lg: '16px' }} fontWeight={{ base: 500, lg: 600 }}>
				{item.label}
			</Text>
		</>
	);
};

const ResultGameTabs = ({ options, activeValue, onChange }) => {
	return (
		<Box
			bgGradient='linear-gradient(180deg, #F7F2F4 0%, #EFF5FF 100%)'
			borderRadius='16px'
			py={3}
			px={{ base: 1, lg: 2 }}
		>
			<OptionTabList gap={1} options={options} activeValue={activeValue} onChange={onChange}>
				{(item) => <ResultGameTabLabel item={item} />}
			</OptionTabList>
		</Box>
	);
};

export default ResultGameTabs;
